module.exports = __webpack_public_path__ + "static/matza_3@2x-6c886a8afe49c882d50f53528b4fc9cc.jpg";